// @ts-strict-ignore
import { Injectable } from '@angular/core';
import { AppConfigService } from './app-config.service';
import { LogLevel, faro } from '@grafana/faro-web-sdk';

@Injectable()
export class LoggingService {
  private _faroEnabled: boolean = false;
  constructor(private config: AppConfigService) {
    this._faroEnabled = this.config.appConfig?.faro !== undefined;
  }

  logPageView(name?: string, url?: string) {
    if (!this._faroEnabled) {
      return;
    }
    faro.api.pushEvent('navigation', {
      name: name,
      url: url,
    });
  }

  logEvent(name: string, properties?: { [key: string]: any }) {
    if (!this._faroEnabled) {
      return;
    }
    faro.api.pushEvent(name, {
      ...properties,
    });
  }

  logMetric(name: string, average: number, properties?: { [key: string]: any }) {
    if (!this._faroEnabled) {
      return;
    }
    faro.api.pushMeasurement({
      type: name,
      values: {
        average: average,
        ...properties,
      },
    });
  }

  logException(exception: Error) {
    if (!this._faroEnabled) {
      return;
    }
    faro.api.pushError(exception);
  }

  logMessage(message: string, context?: { [key: string]: any }, level?: LogLevel) {
    if (!this._faroEnabled) {
      return;
    }
    faro.api.pushLog([], {
      context: context ?? {},
      level: level ?? LogLevel.INFO,
    });
  }
}
